import { render } from "./InformationView.vue?vue&type=template&id=46e89bd6&scoped=true"
import script from "./InformationView.vue?vue&type=script&lang=js"
export * from "./InformationView.vue?vue&type=script&lang=js"

import "./InformationView.vue?vue&type=style&index=0&id=46e89bd6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46e89bd6"]])

export default __exports__